import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'
import InstagramCampaign from '../../organisms/InstagramCampaign'
import OuterLink from '../../atoms/OuterLink'

const Container = styled.aside`
  margin-right: auto;
  width: 200px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    display: none;
  }
`

const ShareButton = styled(OuterLink)`
  display: block;
  margin: 10px auto 0;
  text-decoration: none;
  width: 160px;
`

export default function Right() {
  return (
    <Container>
      <Image alt="パパや友達にオススメしてね！" filename="balloon-share.png" />
      <ShareButton
        to={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
          'https://award.mamari.jp/2020_spring/features/award_all'
        )}`}
      >
        <Image filename="share-line.png" />
      </ShareButton>
      <ShareButton
        to={`https://twitter.com/share?url=${encodeURIComponent(
          'https://award.mamari.jp/2020_spring/features/award_all'
        )}&text=${encodeURIComponent('3,653件の口コミから選ばれた、#ママリ口コミ大賞 アイテム一気見せ！→')}`}
      >
        <Image filename="share-twitter.png" />
      </ShareButton>

      <InstagramCampaign />
    </Container>
  )
}
